import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DealsGrid = ({ deals = [], onDealSelect, selectedDealId, onNewDeal }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })?.format(value || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString)?.toLocaleDateString('pt-BR');
  };

  return (
    <div className="h-full flex flex-col bg-card border-r border-border">
      <div className="p-4 border-b border-border flex items-center justify-between bg-muted/30">
        <div className="flex items-center gap-3">
          <Icon name="TrendingUp" size={20} className="text-primary" />
          <div>
            <h2 className="text-lg font-semibold text-foreground">Negociações</h2>
            <p className="text-xs text-muted-foreground">
              {deals?.length} {deals?.length === 1 ? 'negociação' : 'negociações'} registrada{deals?.length !== 1 ? 's' : ''}
            </p>
          </div>
        </div>
        <Button
          variant="default"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          onClick={onNewDeal}
        >
          Nova Negociação
        </Button>
      </div>

      <div className="flex-1 overflow-y-auto">
        {deals?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-muted/50 flex items-center justify-center mb-4">
              <Icon name="TrendingUp" size={32} className="text-muted-foreground" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Nenhuma Negociação Registrada
            </h3>
            <p className="text-sm text-muted-foreground mb-4 max-w-sm">
              Comece registrando uma nova negociação com seus clientes e fornecedores
            </p>
            <Button
              variant="default"
              iconName="Plus"
              iconPosition="left"
              onClick={onNewDeal}
            >
              Criar Primeira Negociação
            </Button>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {deals?.map(deal => (
              <div
                key={deal?.id}
                onClick={() => onDealSelect(deal?.id)}
                className={`p-4 cursor-pointer transition-colors hover:bg-muted/30 ${
                  selectedDealId === deal?.id ? 'bg-primary/5 border-l-2 border-l-primary' : ''
                }`}
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1">
                    <h3 className="text-sm font-semibold text-foreground mb-1">
                      {deal?.product}
                    </h3>
                    <p className="text-xs text-muted-foreground flex items-center gap-1">
                      <Icon name="User" size={12} />
                      {deal?.clientName}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-bold text-primary">
                      {formatCurrency(deal?.productValueBRL)}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {formatDate(deal?.saleDate)}
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2 mb-3">
                  <div className="bg-muted/30 rounded p-2">
                    <p className="text-[10px] text-muted-foreground uppercase tracking-wide mb-1">
                      Receita
                    </p>
                    <p className="text-xs font-semibold text-foreground">
                      {formatCurrency(deal?.revenue)}
                    </p>
                  </div>
                  <div className="bg-success/10 rounded p-2">
                    <p className="text-[10px] text-muted-foreground uppercase tracking-wide mb-1">
                      Lucro (6%)
                    </p>
                    <p className="text-xs font-semibold text-success">
                      {formatCurrency(deal?.profitWith6Discount)}
                    </p>
                  </div>
                </div>

                <div className="flex items-center justify-between text-xs">
                  <div className="flex items-center gap-1 text-muted-foreground">
                    <Icon name="Truck" size={12} />
                    <span className="truncate max-w-[120px]">
                      {deal?.supplierName}
                    </span>
                  </div>
                  {deal?.invoiceFileName && (
                    <div className="flex items-center gap-1 text-primary">
                      <Icon name="FileText" size={12} />
                      <span>Fatura</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DealsGrid;